import React, { useState, useEffect } from 'react';
import { LuPlus, LuMinus } from "react-icons/lu";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";

import './ExpandableComponent.scss';

const ExpandableComponent = ({ title, subtitle, children, bgColor, defaultExpanded = false, onSubtitleClick, mBottom = "0px" }) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    const toggleExpansion = () => {
        setIsExpanded(!isExpanded);
    };

    useEffect(() => {
        setIsExpanded(defaultExpanded);
    }, [defaultExpanded]);

    return (
        <div className="expandable-container">
            <div className={`expandable-header ${isExpanded ? 'expanded' : 'collapsed'}`} onClick={toggleExpansion}>
                <div className="icon">
                    {isExpanded ? <IoIosArrowUp style={{ height: '30px', width: '30px' }} /> : <IoIosArrowDown style={{ height: '30px', width: '30px' }} />}
                </div>
                {/* <div className="title">{title}</div> */}
                <div className="title" > {title} </div>
                <div className="subtitle" style={{ cursor: onSubtitleClick ? "pointer" : "default" }}
                    onClick={(e) => {
                        e.stopPropagation();
                        onSubtitleClick && onSubtitleClick();
                    }}>
                    {subtitle}
                </div>
            </div>
            <div className={`expandable-content ${isExpanded ? 'expanded' : 'collapsed'}`} style={{ marginBottom: mBottom }}>
                {children}
            </div>
        </div>
    );
};

export default ExpandableComponent;
